import { khuVucSearchColumns, nhomColumns, QUERY_KEYS } from '@/constants';
import { FormField, SearchField } from '@/components/custom/erp';
import { Group, KhuVuc } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoProps {
  formMode: 'add' | 'edit' | 'view';
  parent: KhuVuc | null;
  nh_rg1_group: Group | null;
  nh_rg2_group: Group | null;
  nh_rg3_group: Group | null;
  setParent: (parent: KhuVuc) => void;
  setGroup1: (group: Group) => void;
  setGroup2: (group: Group) => void;
  setGroup3: (group: Group) => void;
}

const BasicInfo: React.FC<BasicInfoProps> = ({
  formMode,
  parent,
  nh_rg1_group,
  nh_rg2_group,
  nh_rg3_group,
  setParent,
  setGroup1,
  setGroup2,
  setGroup3
}) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
      <div className='p-4 md:p-6'>
        <div className='flex flex-col gap-y-4 md:gap-y-6'>
          <div className='space-y-4 md:space-y-6'>
            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã khu vực</Label>
              <FormField
                type='text'
                name='rg_code'
                className='w-full'
                disabled={formMode === 'view' || formMode === 'edit'}
              />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khu vực</Label>
              <FormField type='text' name='rgname' className='w-full' disabled={isViewMode} />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khác</Label>
              <FormField type='text' name='rgname2' disabled={isViewMode} />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Khu vực mẹ</Label>
              <SearchField<KhuVuc>
                type='text'
                displayRelatedField={'rgname'}
                columnDisplay={'rg_code'}
                searchEndpoint={`/${QUERY_KEYS.KHU_VUC}`}
                searchColumns={khuVucSearchColumns}
                dialogTitle='Danh mục khu vực'
                value={parent?.rg_code || ''}
                relatedFieldValue={parent?.rgname || ''}
                onRowSelection={setParent}
                disabled={isViewMode}
                className='w-100'
              />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Nhóm 1</Label>
              <SearchField<Group>
                type='text'
                displayRelatedField={'ten_phan_nhom'}
                columnDisplay={'ma_nhom'}
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=RG1`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm 1'
                value={nh_rg1_group?.ma_nhom || ''}
                relatedFieldValue={nh_rg1_group?.ten_phan_nhom || ''}
                onRowSelection={setGroup1}
                disabled={isViewMode}
                className='w-100'
              />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Nhóm 2</Label>
              <SearchField<Group>
                type='text'
                displayRelatedField={'ten_phan_nhom'}
                columnDisplay={'ma_nhom'}
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=RG2`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm 2'
                value={nh_rg2_group?.ma_nhom || ''}
                relatedFieldValue={nh_rg2_group?.ten_phan_nhom || ''}
                onRowSelection={setGroup2}
                disabled={isViewMode}
                className='w-100'
              />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Nhóm 3</Label>
              <SearchField<Group>
                type='text'
                displayRelatedField={'ten_phan_nhom'}
                columnDisplay={'ma_nhom'}
                searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=RG3`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm 3'
                value={nh_rg3_group?.ma_nhom || ''}
                relatedFieldValue={nh_rg3_group?.ten_phan_nhom || ''}
                onRowSelection={setGroup3}
                disabled={isViewMode}
                className='w-100'
              />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Số thứ tự</Label>
              <FormField type='number' name='stt' disabled={isViewMode} />
            </div>

            <div className='flex flex-col sm:flex-row sm:items-center'>
              <Label htmlFor='status' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
                Trạng thái
              </Label>
              <FormField
                id='status'
                type='select'
                name='status'
                className='w-full'
                disabled={isViewMode}
                options={[
                  { value: '0', label: '0. Không sử dụng' },
                  { value: '1', label: '1. Còn sử dụng' }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
